const Currency = () =>
  import(
    /* webpackChunkName: "base-info-unit-currency" */ '@/pages/base-info/unit/currency/index.vue'
  )
const CreateCurrency = () =>
  import(
    /* webpackChunkName: "base-info-unit-currency" */ '@/pages/base-info/unit/currency/create.vue'
  )
const EditCurrency = () =>
  import(
    /* webpackChunkName: "base-info-unit-currency" */ '@/pages/base-info/unit/currency/edit.vue'
  )

export default {
  path: 'currency',
  meta: {
    label: 'currency',
    auth: 'currency'
  },
  component: {
    name: 'Currency',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoUnitCurrency',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Currency
    },
    {
      name: 'BaseInfoCreateUnitCurrency',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCurrency
    },
    {
      name: 'BaseInfoEditUnitCurrency',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCurrency,
      props: true
    }
  ]
}
